// extracted by mini-css-extract-plugin
export var box = "video-pane-module--box--08572";
export var fullSize = "video-pane-module--full-size--c815a";
export var heading = "video-pane-module--heading--807e8";
export var leftBox = "video-pane-module--leftBox--9560d";
export var networkImg = "video-pane-module--networkImg--51c8e";
export var overlay = "video-pane-module--overlay--9ede4";
export var rightBox = "video-pane-module--rightBox--a6a68";
export var video = "video-pane-module--video--40180";
export var videoPane = "video-pane-module--video-pane--ac47f";